'use strict';

/* globals RELATIVE_PATH */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	Vue.component('text-answer-view', {
		props: ['answer'],
		template: 
		'<div>' +
            '<div class="text-answer"><span>{{answer.content}}</span></div>' +
		'</div>',
	});
});
